import React, { useState } from "react";
import { makeGet } from "@culturehq/client";
import { PlainButton, SearchBar } from "@culturehq/components";
import * as CHQ from "chq";

import { useIncrement } from "app/hooks";

import getUserName from "app/utils/getUserName";
import styles from "./user-search.module.scss";

type UserSearchProps = {
  autoFocus?: boolean;
  excludeIds: number[];
  onUserSelected: (_user: CHQ.User) => void;
  placeholder?: string;
};

const UserSearch: React.FC<UserSearchProps> = ({
  autoFocus = false, excludeIds, onUserSelected, placeholder
}) => {
  const [searchBarKey, incrementSearchBarKey] = useIncrement(1);
  const [users, setUsers] = useState<CHQ.User[]>([]);

  const onSearch = async (query: string) => {
    const response = await makeGet<{ users: CHQ.User[] }>("/autocomplete/users", { query });
    setUsers(response.users.filter(user => !excludeIds.includes(user.id)));
  };

  const onSearchChange = () => setUsers([]);
  const onSelect = (user: CHQ.User) => {
    incrementSearchBarKey();
    setUsers([]);
    onUserSelected(user);
  };

  return (
    <div className={styles.search}>
      <SearchBar
        key={searchBarKey}
        autoFocus={autoFocus}
        onSearch={onSearch}
        onSearchChange={onSearchChange}
        placeholder={placeholder}
      />
      {users.length > 0 && (
        <div className={styles.results}>
          {users.map(user => (
            <PlainButton
              key={user.id}
              className={styles.result}
              onClick={() => onSelect(user)}
            >
              {getUserName(user)} ({user.email})
            </PlainButton>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserSearch;
